import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //exclude specific types from the bearer cloning #. for login
    if (request.body?.userName) {
      return next.handle(request);
    }

    // Get the access token from local storage
    const retrieve = localStorage.getItem('authorizationData');
    let JWTInfo = {accessToken: ''};
    if (retrieve) {
      JWTInfo = JSON.parse(retrieve);
    }
    const accessToken = JWTInfo.accessToken;
    // If the access token exists, add it to the request headers
    if (accessToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }
   
    return next.handle(request);
  }
}
